<template lang="pug">
  #signUpIndex
    .container-width.p-3
      //- h5.titleStyle.text-center.font-weight-bold.mb-4 申請LINE個人化服務
      #step1(v-if="nowStep == 1")
        .text-area-scroll.mb-2
          .line-text-header.mb-2
            .title.font-weight-bold 貼心提醒
          .line-text-body.py-2.text-justify
            p 當日消費並成為hearth香港商心連天地有限公司台灣分公司及其關係企業(以下簡稱華敦集團)之顧客者，於申請LINE官方帳號綁定服務時，華敦集團會依據您所提供的出生年月日、行動電話與LINE帳號進行身分驗證，本查詢與驗證服務不會經由LINE記錄資料，僅於本Line官方帳號系統執行。
            p 綁定個人化服務成功後，若您重新安裝LINE APP或更換手機，須以原本LINE ID登入，方可使用後續的LINE個人化服務。
            p 成功綁定個人化服務後，即同意華敦集團及其關係企業或合作廠商等以符合本公司隱私權政策之方式，使用您所提供的個人資料與您確認身分、進行連絡、提供商品相關服務與資訊(包含但不限於商品行銷活動、DM、簡訊、或電子報寄送、廣告資料等宣傳目的及顧客統計或分析範圍內使用)，並串接華敦集團系統作為會員管理、客戶管理之檢索查詢、辨識身分、金流服務、物流服務、行銷廣宣等。
          .line-text-bottom
        .d-flex.justify-content-center
          b-form-checkbox.text-center.font-weight-bold.mb-3(
            id="agree"
            v-model="agree_status"
            name="agree"
            :value="true"
            :unchecked-value="false"
          ) 我已詳閱並同意 hearth
          label.ml-1.font-weight-bold(for="" style='text-decoration: underline' @click='showNoticeHandler()') 個資告知事項
        .px-4.fakePadding_h-50.position-relative
          button.button.btn-block.button_clickCustom.button_clickCustom-primary.button_fixedAtBottom.position-absolute(
            @click="nextStepHandler()"
          )
            | 下一步
      #step2(v-if="nowStep == 2")
        .mb-4.mb-2
          p 請輸入行動電話號碼，您所輸入的資料需與留存於 {{ companyName }} 系統的資料相同
            | 。
        b-card.border-0.mb-2(
          bg-variant="light"
        )
          ValidationObserver(
            ref="mobileForm"
            tag="form"
            @submit.stop.prevent="submitHandler"
          )
            //- b-form-group
            //-   ValidationProvider(
            //-     rules="required",
            //-     ref="inputValName"
            //-   )
            //-     label(
            //-       for="name"
            //-     )
            //-       i.fas.fa-user.fa-lg.mx-1
            //-       code *
            //-       span 姓名
            //-     .row
            //-       .col-6
            //-         b-form-input(
            //-           id="lastName",
            //-           type="text",
            //-           required,
            //-           trim,
            //-           :state="validState('lastName')",
            //-           v-model="userForm.lastName",
            //-           aria-describedby="input-live-help input-name-live-feedback",
            //-           placeholder="請輸入姓"
            //-         )
            //-         b-form-invalid-feedback(
            //-           id="input-name-live-feedback"
            //-         )
            //-           span 此欄不可為空
            //-       .col-6
            //-         b-form-input(
            //-           id="firstName",
            //-           type="text",
            //-           required,
            //-           trim,
            //-           :state="validState('firstName')",
            //-           v-model="userForm.firstName",
            //-           aria-describedby="input-live-help input-name-live-feedback",
            //-           placeholder="請輸入名"
            //-         )
            //-         b-form-invalid-feedback(
            //-           id="input-name-live-feedback"
            //-         )
            //-           span 此欄不可為空
            b-form-group.m-0
              ValidationProvider(
                rules="required|mobile",
                ref="inputValMobile",
                v-slot="{ errors }"
              )
                b-form-input.inputStyle(
                  id="mobile",
                  type="tel",
                  required,
                  trim,
                  :state="validState('mobile')",
                  v-model="userForm.mobile",
                  aria-describedby="input-live-help input-name-live-feedback",
                  placeholder="請輸入手機"
                )
                b-form-invalid-feedback.text-center(
                  id="input-name-live-feedback"
                )
                  span {{ errors[0] }}
        //-     b-form-group
        //-       ValidationProvider(
        //-         rules="required|verify",
        //-         ref="inputValVerify",
        //-         v-slot="{ errors }"
        //-       )
        //-         label(
        //-           for="store"
        //-         )
        //-           i.fas.fa-key.fa-lg.mx-1
        //-           code *
        //-           span 驗證碼
        //-         .row.no-gutters
        //-           .col-md-8.col-6.pr-1.d-flex.align-items-center.flex-wrap
        //-             b-form-input.w-100(
        //-               id="verify",
        //-               type="text",
        //-               required,
        //-               trim,
        //-               :state="validState('verify')",
        //-               v-model="userForm.verify",
        //-               aria-describedby="input-live-help input-name-live-feedback",
        //-               placeholder="請輸入驗證碼"
        //-             )
        //-             b-form-invalid-feedback.w-100(
        //-               id="input-name-live-feedback"
        //-             )
        //-               span {{ errors.length === 0 ? '驗證碼錯誤' : errors[0] }}
        //-           .col-md-4.col-6.pl-1
        //-             .d-flex.align-items-center.justify-content-between
        //-               VerifyComponent(
        //-                 ref="VerifyComponent"
        //-               )
        //-               i.fas.fa-sync-alt.fa-lg(
        //-                 @click="changeVerifyCodeHandler"
        //-               )
        //- p.text-center.mb-3
        //-   code *字號
        //-   span 為選填選項，其餘選項皆為必填
        .px-4
          button.button.btn-block.button_clickCustom.button_clickCustom-primary.button_fixedAtBottom(
            type="button",
            @click="nextStepHandler()"
          )
            | 下一步
      #step3(v-if="nowStep == 3")
        .mb-4
          p.text-center 請輸入發送至您手機的驗證碼
        b-card.border-0.mb-2(
          bg-variant="light"
        )
          ValidationObserver(
            ref="mobileVerfityForm"
            tag="form"
            @submit.stop.prevent="checkSMS()"
          )
            b-form-group.mb-0
              ValidationProvider(
                rules="required",
                ref="inputValMobileVerfity"
              )
                b-form-input.inputStyle(
                  id="mobileVerfity",
                  type="text",
                  required,
                  trim,
                  :state="validverfityState()",
                  v-model="mobileVerfityCode",
                  aria-describedby="input-live-help input-name-live-feedback",
                  placeholder="請輸入驗證碼"
                )
                b-form-invalid-feedback(
                  id="input-name-live-feedback"
                )
                  span 簡訊驗證碼不可為空
              .text-center
                  .mt-2(
                    v-if="verfityNowTime == 0"
                  )
                    button.btn.btn-black.rounded-50.mt-2(
                      type="button",
                      @click="countDownHandler"
                    )
                      i.fas.fa-redo.fa-md.arrorIcon.pr-1
                      span 重發驗證碼
                  .mt-2(
                    v-else
                  )
                    code {{ verfityNowTime }}秒
                    span 後可重發驗證碼
        .px-4
          button.button.btn-block.button_clickCustom.button_clickCustom-primary.button_fixedAtBottom(
            type="button",
            @click="nextStepHandler()"
          )
            | 下一步
      #step4(v-if="nowStep == 4")
        b-card.border-0.mb-2(
          bg-variant="light"
        )
          ValidationObserver(
            ref="userForm"
            tag="form"
            @submit.stop.prevent="submitHandler"
          )
            b-form-group
              ValidationProvider(
                rules="required",
                ref="inputValName",
                v-slot="{ errors }"
              )
                b-form-input.inputStyle(
                  id="name",
                  type="text",
                  required,
                  trim,
                  :state="validState('name')",
                  v-model="userForm.name",
                  aria-describedby="input-live-help input-name-live-feedback",
                  placeholder="請輸入姓名"
                  :disabled='disabledName'
                )
                b-form-invalid-feedback.text-center(
                  id="input-name-live-feedback"
                )
                  span {{ errors[0] }}
            b-form-group
              ValidationProvider(
                rules="required|mobile",
                ref="inputValMobile",
                v-slot="{ errors }"
              )
                b-form-input.inputStyle(
                  id="mobile",
                  type="tel",
                  required,
                  trim,
                  :state="validState('mobile')",
                  v-model="userForm.mobile",
                  aria-describedby="input-live-help input-mobile-live-feedback",
                  placeholder="請輸入手機"
                  disabled
                )
                b-form-invalid-feedback.text-center(
                  id="input-mobile-live-feedback"
                )
                  span {{ errors[0] }}

            b-form-group(v-show='showSex')
              ValidationProvider(
                rules="required",
                ref="inputValGender",
                v-slot="{ errors, valid }"
              )
                multiselect.multiselect__circle(
                  track-by="id",
                  label="name",
                  placeholder="請選擇性別",
                  :options="genderDropdown",
                  :searchable="false",
                  :allow-empty="false",
                  v-model="userForm.selectedGender",
                  selectLabel='',
                  deselect-label='',
                  noOptions="無可選擇性別"
                  :state="validState('gender')",
                  :class="{ 'has-value': userForm.selectedGender, 'is-invalid': errors[0], 'is-valid': valid }"
                )
                  template(slot="noOptions")
                    strong 無可選擇性別
                b-form-invalid-feedback.text-center(
                  id="input-mobile-live-feedback"
                )
                  span {{ errors[0] }}

            b-form-group.mb-0(v-show='showBirthday')
              .d-flex.no-gutters
                .col-4
                  ValidationProvider(
                    rules="required",
                    ref="inputValBirthYear",
                    v-slot="{ errors, valid }"
                  )
                    multiselect.multiselect__circle(
                      track-by="id",
                      label="title",
                      placeholder="生日年",
                      :options="birthYearOptions",
                      :searchable="false",
                      :allow-empty="false",
                      v-model="userForm.birthYear",
                      selectLabel='',
                      deselect-label='',
                      :class="{ 'has-value': userForm.birthYear, 'is-invalid': errors[0], 'is-valid': valid }"
                      @select='changeBirthDateOption()'
                    )
                      template(slot="noOptions")
                        strong 無可選擇年份
                    b-form-invalid-feedback.text-center(
                      id="input-name-live-feedback"
                    )
                      span {{ errors[0] }}

                .col-4
                  ValidationProvider(
                    rules="required",
                    ref="inputValBirthMonth",
                    v-slot="{ errors, valid }"
                  )
                    multiselect.multiselect__circle(
                      track-by="id",
                      label="title",
                      placeholder="月",
                      :options="birthMonthOptions",
                      :searchable="false",
                      :allow-empty="false",
                      v-model="userForm.birthMonth",
                      selectLabel='',
                      deselect-label='',
                      :class="{ 'has-value': userForm.birthMonth, 'is-invalid': errors[0], 'is-valid': valid }"
                      :disabled='disabledBirthMonth'
                      @select='changeBirthDateOption()'
                    )
                      template(slot="noOptions")
                        strong 無可選擇月份
                    b-form-invalid-feedback.text-center(
                      id="input-name-live-feedback"
                    )
                      span {{ errors[0] }}
                .col-4
                  ValidationProvider(
                    rules="required",
                    ref="inputValBirthDate",
                    v-slot="{ errors, valid }"
                  )
                    multiselect.multiselect__circle(
                      track-by="id",
                      label="title",
                      placeholder="日",
                      :options="birthDateOptions",
                      :searchable="false",
                      :allow-empty="false",
                      v-model="userForm.birthDate",
                      selectLabel='',
                      deselect-label='',
                      :class="{ 'has-value': userForm.birthDate, 'is-invalid': errors[0], 'is-valid': valid }"
                    )
                      template(slot="noOptions")
                        strong 無可選擇日期
                    b-form-invalid-feedback.text-center(
                      id="input-name-live-feedback"
                    )
                      span {{ errors[0] }}

          label.redRemind(style="font-size: 12px" v-if="showSex || showBirthday") *請正確填寫真實姓名、{{ showBirthday ? '生日' : ''}}{{ showSex ? '及性別' : '' }}，填寫後即無法修改
          b-form-group
            ValidationProvider(
              rules="required",
              ref="inputValGender",
              v-slot="{ errors }"
            )
              multiselect.multiselect__circle(
                track-by="no",
                label="name",
                placeholder="請選擇消費櫃點",
                :options="storeDropdown",
                :searchable="false",
                :allow-empty="false",
                v-model="userForm.selectedStore",
                selectLabel='',
                deselect-label='',
                noOptions="無可選擇櫃點"
                :class="{ 'is-invalid': errors[0] }"
              )
                template(slot="noOptions")
                  strong 無可選擇櫃點
              b-form-invalid-feedback.text-center(
                id="input-mobile-live-feedback"
              )
                span {{ errors[0] }}

          b-form-group
            ValidationProvider(
              rules="required",
              ref="inputValCity",
              v-slot="{ errors }"
            )
              multiselect.multiselect__circle(
                track-by="id",
                label="city_name",
                placeholder="請選擇居住縣市",
                :options="cityOption",
                :searchable="false",
                :allow-empty="false",
                v-model="city",
                selectLabel='',
                deselect-label='',
                noOptions="無可選擇縣市"
                :class="{ 'is-invalid': errors[0] }"
                @select='changeAreaOption'
              )
                template(slot="noOptions")
                  strong 無可選擇縣市
              b-form-invalid-feedback.text-center(
                id="input-mobile-live-feedback"
              )
                span {{ errors[0] }}
          b-form-group
            ValidationProvider(
              rules="required",
              ref="inputValZip",
              v-slot="{ errors }"
            )
              multiselect.multiselect__circle(
                track-by="zip_no",
                label="zip_name",
                placeholder="請選擇居住地區",
                :options="zipNaOption",
                :searchable="false",
                :allow-empty="false",
                v-model="zip_na",
                selectLabel='',
                deselect-label='',
                noOptions="無可選擇地區"
                :class="{ 'is-invalid': errors[0] }"
              )
                template(slot="noOptions")
                  strong 無可選擇地區
              b-form-invalid-feedback.text-center(
                id="input-mobile-live-feedback"
              )
                span {{ errors[0] }}

        label 親愛的顧客請注意，為了通知與提醒您的相關權益與福利，我們會藉由以下方式聯繫您，如有不想接受的聯繫方式，請您勾選，謝謝
        b-form-group
          b-form-checkbox(
            :id="`checkbox-pr-1`",
            name="selectTemps1",
            v-model="userForm.pr_phone",
          ) 不接受電話
        b-form-group.mb-3.pb-5
          b-form-checkbox(
            :id="`checkbox-pr-2`",
            name="selectTemps2",
            v-model="userForm.pr_sms",
          ) 不接受簡訊
            span(style="font-size: 15px") (勾選不接受仍將會收到生日、會籍到期及消費抽樣滿意度簡訊)
            
        //b-form-group
        //  b-form-checkbox(
        //    :id="`checkbox-pr-3`",
        //    name="selectTemps3",
        //    v-model="userForm.pr_letter",
        //  ) 不接受郵寄
        //b-form-group.mb-3.pb-5
        //  b-form-checkbox(
        //    :id="`checkbox-pr-4`",
        //    name="selectTemps4",
        //    v-model="userForm.pr_email",
        //  ) 不接受email
            //b-form-group.mb-0
              ValidationProvider(
                rules="required|verify",
                ref="inputValVerify",
                v-slot="{ errors }"
              )
                .row.no-gutters
                  .col-md-8.col-6.pr-1.d-flex.align-items-center.flex-wrap
                    b-form-input.w-100.verifyInput(
                      id="verify",
                      type="text",
                      required,
                      trim,
                      :state="validState('verify')",
                      v-model="userForm.verify",
                      aria-describedby="input-live-help input-name-live-feedback",
                      placeholder="請輸入驗證碼"
                    )
                    b-form-invalid-feedback.w-100(
                      id="input-name-live-feedback"
                    )
                      span {{ errors.length === 0 ? '驗證碼錯誤' : errors[0] }}
                  .col-md-4.col-6.pl-1
                    .d-flex.align-items-center.justify-content-between
                      VerifyComponent(
                        ref="VerifyComponent"
                      )
                      i.fas.fa-sync-alt.fa-lg.refreshIcon.ml-2(
                        @click="changeVerifyCodeHandler"
                      )
          //p.text-center.pb-5.position-relative
            code *字號
            span 為選填選項，其餘選項皆為必填

        .px-4.pt-2.position-relative
          button.button.btn-block.button_clickCustom.button_clickCustom-primary.button_fixedAtBottom.position-absolute(
            type="button",
            @click="nextStepHandler()"
          )
            | 下一步

    NoticeModel

</template>

<script>
import { mapState } from 'vuex';
import StepComponent from '@/components/step/StepComponent.vue'; // 客製化進度條
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'; // 檢查套件
import { required } from 'vee-validate/dist/rules';
import VerifyComponent from '@/components/verify/VerifyComponent.vue'; // 驗證套件
import NoticeModel from '@/components/customerModel/noticeModel.vue';

import { M_SIGN_UP_SUCCESS } from '@/router/member/sign-up';

const _ = require('lodash');
const moment = require('moment');

// 獲取所有驗證條件
extend('required', {
  ...required,
  message: '此欄不可為空'
});

// 客製化身分證驗證
extend('mobile', {
  validate: (val) => {
    const MobileReg = /^(09)[0-9]{8}$/;
    return MobileReg.test(val);
  },
  message: '行動電話格式錯誤'
});

// 客製化驗證套件
extend('verify', {
  validate: (val) => {
    if (VerifyComponent.data.varifyAnswer === undefined) return true;
    return val === VerifyComponent.data.varifyAnswer ? true : false;
  },
  message: '驗證碼錯誤'
});

export default {
  name: 'SignUpIndex',
  components: {
    StepComponent,
    ValidationProvider,
    ValidationObserver,
    VerifyComponent,
    NoticeModel,
  },
  props: {
    sa_id: {
      type: [String, Number],
      required: false
    },
    store_id: {
      type: [String, Number],
      required: false
    }
  },
  data() {
    return {
      companyName: 'hearth',
      nowStep: 1,
      agree_status: false,
      firstType: true, // 第一次進來輸入資料
      userForm: {
        lastName: null,
        firstName: null,
        mobile: null,
        verify: null,
        name: null,
        selectedStore: null,
        selectedGender: null,
        birthYear: null,
        birthMonth: null,
        birthDate: null,
        pr_phone: 0,
        pr_sms: 0,
        pr_letter: 0,
        pr_email: 0
      },
      mobileVerfityCode: null,
      verfityTotalTime: 180,
      verfityNowTime: 0,
      verfityCanClick: true,
      disabledName: false,
      genderDropdown: [
        {
          id: 1,
          name: '男'
        },
        {
          id: 0,
          name: '女'
        },
        {
          id: 2,
          name: '不透露'
        },
      ],
      birthYearOptions: [],
      birthMonthOptions: [],
      birthDateOptions: [],
      showBirthday: true,
      showSex: true,
      city: null,
      zip_na: null,
      cityOption: [],
      zipNaOption: [],
      disabledBirthMonth: false,
      binding_gift_status: false,
    };
  },
  computed: {
    ...mapState({
      storeDropdown: (state) => state.member_sign_up.storeDropdown,
      storePersonnelDropdown: (state) => state.member_sign_up.storePersonnelDropdown,
      cityDropdown: (state) => state.member_sign_up.cityDropdown,
    })
  },
  mounted() {
    const vm = this;
    for (let i = 0; i < 100; i++) {
      vm.birthYearOptions.push({
        id: moment().subtract(i, 'year').format('YYYY'),
        title: moment().subtract(i, 'year').format('YYYY')
      });
    }
    for (let i = 1; i <= 12; i++) {
      vm.birthMonthOptions.push({
        id: i < 10 ? `0${i}` : i,
        title: i
      });
    }
    // 檢查綁定狀態
    // 檢查綁定狀態
    vm.$store.dispatch('member_sign_up/checkIsMemberHandler')
      .then((res) => {
        if (res.type === 'temp_binding') {
          vm.$store.commit('toggleLoading', false);
          vm.$swal.fire({
            icon: 'info',
            title: '您的資料已送出',
            html: '請前往官網註冊會員',
            confirmButtonText: '前往註冊'
          }).then(() => {
            window.location.href = process.env.VUE_APP_OFFICIAL_URL;
          });
        } else if (res.type !== 'not_binding') {
          vm.$swal.fire({
            icon: 'info',
            title: '您已綁定，請勿重複綁定'
          }).then(() => {
            window.location.href = process.env.VUE_APP_LINE_ADD_FRIEND_LINK;
          });
        } else {
          //綁定連結紀錄貼標
          if (vm.$route.params.bindingId) {    
            vm.$store.dispatch('member_sign_up/getBindingGiftCheckHandler', {
              binding_gift_uid: vm.$route.params.bindingId
            }).then((res) => {
              if (res.data.is_effective) {
                if (Object.prototype.hasOwnProperty.call(res.data, 'is_eticket') && res.data.is_eticket === false) {
                  vm.binding_gift_status = false;
                  vm.$swal.fire({
                    icon: 'info',
                    title: '綁定禮已發送完畢，感謝您的參與。',
                    html: '系統將前往一般會員綁定流程<br>完成綁定享有會員專屬權益'
                  });
                } else {
                  vm.binding_gift_status = true;
                  vm.$store.dispatch('member_sign_up/postBindingGiftUserTagHandler', {
                    binding_gift_uid: vm.$route.params.bindingId,
                    action: 'click_link'
                  });
                }
              } else {
                vm.binding_gift_status = false;
                vm.$swal.fire({
                  icon: 'info',
                  title: '綁定禮活動已結束，感謝您的參與。',
                  html: '系統將前往一般會員綁定流程<br>完成綁定享有會員專屬權益'
                });
              }
            });
          }
        }
        vm.$store.commit('toggleLoading', false);

        // 取得縣市地區下拉
        vm.$store.dispatch('member_sign_up/getCityDropdownHandler').then(() => {
          vm.cityOption = vm.cityDropdown;
        });
      });
  },
  methods: {
    nextStepHandler() {
      const vm = this;
      switch (vm.nowStep.toString()) {
      case '1':
        if (!vm.agree_status) {
          this.$swal.fire({
            icon: 'info',
            title: '請勾選同意事項'
          });
        } else {
          vm.nowStep = 2;
        }
        break;
      case '2':
        vm.countDownHandler();
        break;
      case '3':
        vm.checkSMS();
        break;
      case '4':
        vm.sendBindingInfo();
        break;
      default:
        break;
      }
    },
    // 送出手機驗證
    async mobileVerfityHandler() {
      const vm = this;
      const isValid = await this.$refs.mobileVerfityForm.validate();
      if (!isValid) {
        if (vm.mobileVerfityCode === null) {
          vm.mobileVerfityCode = '';
        }
        vm.$swal.fire({
          icon: 'error',
          title: '請填寫驗證碼'
        });
      } else {
        vm.$swal.fire({
          title: '表單送出中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            vm.$swal.showLoading();
          }
        });

        const validateInfo = {
          chinese_last_name: vm.userForm.lastName,
          chinese_first_name: vm.userForm.firstName,
          mobile: vm.userForm.mobile,
          code: vm.mobileVerfityCode
        };

        if (vm.sa_id && vm.store_id) {
          validateInfo.sa_id = vm.sa_id;
          validateInfo.store_id = vm.store_id;
        }

        // 送出並綁定
        vm.$store.dispatch('member_sign_up/validateSmsAndBindingHandler', validateInfo)
          .then(() => {
            this.$swal.close();
            if (vm.sa_id && vm.store_id) {
              vm.$router.push({
                name: M_SIGN_UP_SUCCESS,
                params: {
                  singUpAndBindSa: true
                }
              });
            } else {
              vm.$router.push({
                name: M_SIGN_UP_SUCCESS
              });
            }
          });
      }
    },
    // 檢查欄位
    validState(key) {
      const vm = this;
      if (vm.userForm[key] !== null) {
        if (key === 'mobile') {
          const MobileReg = /^(09)[0-9]{8}$/;
          return MobileReg.test(vm.userForm[key]);
        }
        if (key === 'email') {
          const EmailReg = /^[^\s]+@[^\s]+\.[^\s]{2,3}$/;
          return EmailReg.test(vm.userForm[key]);
        }
        if (key === 'verify') {
          return vm.userForm.verify === vm.$refs.VerifyComponent.varifyAnswer ? true : false;
        }
        return this.userForm[key] ? true : false;
      }
      return null;
    },
    validverfityState() {
      const vm = this;
      if (vm.mobileVerfityCode !== null) {
        return this.mobileVerfityCode ? true : false;
      }
      return null;
    },
    // 倒數驗證碼
    countDownHandler() {
      const vm = this;
      if (!vm.userForm.mobile) {
        vm.$swal.fire({
          title: '請填寫手機號碼',
          icon: 'info'
        });
        return;
      }
      vm.$swal.fire({
        allowOutsideClick: false,
        willOpen: () => {
          vm.$swal.showLoading();
        }
      });
      if (!vm.verfityCanClick) return;
      // 發送驗證碼
      vm.$store.dispatch('member_sign_up/sendSmsValidateHandler', vm.userForm.mobile)
        .then(() => {
          vm.$swal.close();
          vm.nowStep = 3;
          vm.$snotify.success(null, '驗證碼已寄出');
          vm.verfityCanClick = false;
          vm.verfityNowTime = vm.verfityTotalTime;
          const clock = window.setInterval(() => {
            if (vm.verfityNowTime === 0) {
              window.clearInterval(clock);
              vm.verfityCanClick = true; // 這裡重新開啟
            } else {
              vm.verfityNowTime -= 1;
            }
          }, 1000);
        });
    },
    changeVerifyCodeHandler() {
      const vm = this;
      vm.$refs.VerifyComponent.changeVerifyCodeHandler();
    },
    checkSMS() {
      const vm = this;
      const input = {
        mobile: vm.userForm.mobile,
        code: vm.mobileVerfityCode
      };
      vm.$swal.fire({
        allowOutsideClick: false,
        willOpen: () => {
          vm.$swal.showLoading();
        }
      });

      vm.$refs.mobileVerfityForm.validate().then((res) => {
        if (res) {
          vm.$store.dispatch('member_sign_up/checkSMSHandler', input).then(() => {
            vm.$store.dispatch('member_sign_up/getMemberCrmInfoHandler', vm.userForm.mobile).then((res2) => {
              if (res2.data) {
                if (res2.data.VipNa) {
                  vm.userForm.name = res2.data.VipNa;
                  vm.disabledName = true;
                }
                if (res2.data.Birthday) {
                  vm.disabledBirthMonth = true;
                  const bParts = res2.data.Birthday.split('/');
                  vm.userForm.birthYear = { id: bParts[0], title: bParts[0] };
                  vm.userForm.birthMonth = { id: bParts[1], title: parseInt(bParts[1]) };
                  vm.changeBirthDateOption();
                  vm.userForm.birthDate = { id: bParts[2], title: parseInt(bParts[2]) };
                }

                switch (res2.data.Sex) {
                  case 'F':
                    vm.userForm.selectedGender = {
                      id: 0,
                      name: '女'
                    };
                    break;
                  case 'M':
                    vm.userForm.selectedGender = {
                      id: 1,
                      name: '男'
                    };
                    break;
                  case '':
                    vm.userForm.selectedGender = {
                      id: 2,
                      name: '不透露'
                    };
                    break;
                  default:
                    vm.userForm.selectedGender = {
                      id: 2,
                      name: '不透露'
                    };
                    break;
                }
                // 取得店舖下拉
                const data = {
                  vip_no: res2.data.VipNo
                };
                vm.$store.dispatch('member_sign_up/getRecommendStoresHandler', data).then(() => {

                });
                if (res2.data.City && res2.data.City.trim() !== '') {
                  const cityKey = _.findKey(vm.cityDropdown, (val) => val.city_name === res2.data.City);
                  vm.$set(vm, 'city', vm.cityDropdown[cityKey]);
                  vm.changeAreaOption(vm.city);
                  const zipNaKey = _.findKey(vm.cityDropdown[cityKey].zip, (val) => val.zip_no === res2.data.ZipNo);
                  vm.$set(vm, 'zip_na', vm.cityDropdown[cityKey].zip[zipNaKey]);
                }
              } else {
                // 取得店舖下拉
                const data = {
                  vip_no: ''
                };
                vm.$store.dispatch('member_sign_up/getRecommendStoresHandler', data).then(() => {

                });
              }

              vm.$swal.close();
              vm.nowStep = 4;
            });
          });
        } else {
          if (vm.mobileVerfityCode === null) {
            vm.mobileVerfityCode = '';
          }
          vm.$swal.fire({
            icon: 'error',
            title: '請填寫驗證碼'
          });
          vm.$swal.close();
        }
      });
    },

    sendBindingInfo() {
      const vm = this;
      vm.$refs.userForm.validate().then((res) => {
        if (vm.userForm.name === null) vm.userForm.name = '';
        if (vm.userForm.mobile === null) vm.userForm.mobile = '';
        if (vm.userForm.selectedStore === null) vm.userForm.selectedStore = '';
        if (vm.userForm.selectedGender === null) vm.userForm.selectedGender = '';
        if (vm.userForm.birthYear === null) vm.userForm.birthYear = '';
        if (vm.userForm.birthMonth === null) vm.userForm.birthMonth = '';
        if (vm.userForm.birthDate === null) vm.userForm.birthDate = '';
        if (vm.userForm.verify === null) vm.userForm.verify = '';
        if (vm.city === null) vm.city = '';
        if (vm.zip_na === null) vm.zip_na = '';

        if (!vm.userForm.name) {
          vm.$swal.fire({
            icon: 'info',
            title: '請填寫姓名'
          });
        } else if (!vm.userForm.mobile) {
          vm.$swal.fire({
            icon: 'info',
            title: '請填寫手機'
          });
        } else if (!vm.userForm.selectedStore) {
          vm.$swal.fire({
            icon: 'info',
            title: '請選擇櫃點'
          });
        } else if (!vm.userForm.selectedGender) {
          vm.$swal.fire({
            icon: 'info',
            title: '請選擇性別'
          });
        } else if (!vm.userForm.birthYear) {
          vm.$swal.fire({
            icon: 'info',
            title: '請選擇生日年'
          });
        } else if (!vm.userForm.birthMonth) {
          vm.$swal.fire({
            icon: 'info',
            title: '請選擇生日月'
          });
        } else if (!vm.userForm.birthDate) {
          vm.$swal.fire({
            icon: 'info',
            title: '請選擇生日日'
          });
        } else if (!vm.city) {
          vm.$swal.fire({
            icon: 'info',
            title: '請選擇縣市'
          });
        } else if (!vm.zip_na) {
          vm.$swal.fire({
            icon: 'info',
            title: '請選擇地區'
          });
        } else {
          vm.$swal.fire({
            allowOutsideClick: false,
            willOpen: () => {
              vm.$swal.showLoading();
            }
          });
          const input = {
            chinese_first_name: vm.userForm.name,
            mobile: vm.userForm.mobile,
            store_no: vm.userForm.selectedStore.no,
            gender: vm.userForm.selectedGender.id,
            birthday: `${ vm.userForm.birthYear.id }/${ vm.userForm.birthMonth.id }/${ vm.userForm.birthDate.id }`,
            code: vm.mobileVerfityCode,
            pr_phone: vm.userForm.pr_phone ? 1 : 0,
            pr_sms: vm.userForm.pr_sms ? 1 : 0,
            zip_no: vm.zip_na.zip_no
          };
          if (vm.binding_gift_status) {
            input.binding_gift_uid = vm.$route.params.bindingId;
          }
          vm.$store.dispatch('member_sign_up/sendBindingHandler', input).then(() => {
            vm.$swal.close();
            //綁定連結紀錄貼標
            if (vm.binding_gift_status) {
              vm.$store.dispatch('member_sign_up/postBindingGiftUserTagHandler', {
                binding_gift_uid: vm.$route.params.bindingId,
                action: 'completed_bind'
              });
            }
            vm.$router.push({
              name: M_SIGN_UP_SUCCESS
            });
          });
        }
      });
    },
    changeBirthDateOption() {
      const vm = this;
      vm.userForm.birthDate = null;
      vm.birthDateOptions = [];
      setTimeout(() => {
        if (vm.userForm.birthYear && vm.userForm.birthMonth) {
          const yearVal = vm.userForm.birthYear.id;
          const monthVal = vm.userForm.birthMonth.id;
          const lastDateOfMonth = moment(`${yearVal}-${monthVal}`, 'YYYY-MM').endOf('month').format('DD');
          for (var i = 1; i <= lastDateOfMonth; i++) {
            vm.birthDateOptions.push({
              id: i < 10 ? `0${i}` : `${i}`,
              title: i
            });
          }
        }
      }, 50);
    },
    showNoticeHandler() {
      const vm = this;
      vm.$EventBus.$emit('openNoticeModel');
    },
    changeAreaOption(val) {
      const vm = this;
      vm.zip_na = null;
      vm.zipNaOption = val.zip;
    }
  }
};
</script>

<style>

</style>
